import { useQuery, QueryHookOptions } from '@apollo/react-hooks';
import { GET_IGDM_RESOURCES_QUERY } from '@frontend/app/queries';
import {
  GetIGDMResourcesQuery,
  GetIGDMResourcesQueryVariables,
} from '@frontend/app/queries/types/GetIGDMResourcesQuery';

type TOptions = QueryHookOptions<GetIGDMResourcesQuery, GetIGDMResourcesQueryVariables>;

export const useGetIGDMResourcesQuery = (options: TOptions) =>
  useQuery<GetIGDMResourcesQuery, GetIGDMResourcesQueryVariables>(GET_IGDM_RESOURCES_QUERY, options);
